import { useState } from 'react';
import { Link } from 'react-router-dom';

interface FeaturedItem {
  slug: string;
  title: string;
  excerpt: string;
  badge: string;
  date: string;
  views: number;
  comments: number;
  imageUrl: string;
}

const featuredArticles: FeaturedItem[] = [
  {
    slug: 'top-star-live-collapse-2026',
    title: '某顶流男星直播中口误自爆恋情，粉丝当场破防脱粉回踩',
    excerpt: '直播间10万人在线见证塌房现场，一句口误引爆全网热议，超话瞬间沦陷',
    badge: '爆',
    date: '2026-07-06',
    views: 1280000,
    comments: 45600,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20industry%20scene%20with%20a%20celebrity%20on%20live%20stream%20looking%20shocked%20and%20regretful%2C%20dark%20studio%20lighting%20with%20red%20and%20blue%20neon%20accents%2C%20intense%20atmosphere%20with%20floating%20chat%20comments%20in%20the%20background%2C%20cinematic%20composition%2C%20high%20contrast%2C%20moody%20editorial%20photography%20style%2C%20deep%20shadows%20and%20bright%20highlights%2C%20abstract%20digital%20glitch%20effects%2C%20professional%20color%20grading%20with%20warm%20and%20cool%20contrast&width=800&height=1067&seq=featured-hot-01&orientation=portrait',
  },
  {
    slug: 'wanghong-fake-products-scandal',
    title: '千万粉美妆博主被扒售卖假货，品牌方联合发律师函',
    excerpt: '多家品牌方联合声明从未授权，涉事博主紧急删除所有推广视频',
    badge: '热',
    date: '2026-07-06',
    views: 956000,
    comments: 32100,
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20cosmetics%20and%20skincare%20products%20scattered%20on%20a%20marble%20table%20with%20legal%20documents%20and%20a%20warning%20letter%2C%20dramatic%20lighting%20with%20window%20light%20and%20shadows%2C%20investigative%20journalism%20mood%2C%20macro%20detail%20of%20product%20labels%20showing%20counterfeit%20signs%2C%20cinematic%20still%20life%20photography%2C%20dark%20and%20moody%20atmosphere%20with%20touches%20of%20gold%20packaging%2C%20editorial%20style%2C%20high%20detail%20texture%20on%20product%20surfaces&width=800&height=1067&seq=featured-hot-02&orientation=portrait',
  },
  {
    slug: 'variety-show-contestant-exposed',
    title: '选秀节目选手被曝学历造假，节目组紧急发声明切割',
    excerpt: '网友扒出选手真实学历与简历严重不符，三大平台同步下线相关内容',
    badge: '爆',
    date: '2026-07-06',
    views: 2100000,
    comments: 78900,
    imageUrl: 'https://readdy.ai/api/search-image?query=Television%20variety%20show%20stage%20with%20dramatic%20spotlight%20on%20an%20empty%20center%20position%2C%20scattered%20documents%20and%20certificates%20on%20the%20floor%2C%20dark%20background%20with%20stage%20lighting%20beams%2C%20entertainment%20industry%20controversy%20atmosphere%2C%20cinematic%20wide%20shot%2C%20theatrical%20lighting%20with%20blue%20and%20white%20spotlights%2C%20moody%20and%20dramatic%2C%20high%20contrast%20professional%20photography%2C%20empty%20stage%20suggesting%20absence%20and%20scandal&width=800&height=1067&seq=featured-hot-03&orientation=portrait',
  },
];

export default function FeatureGrid() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950">
            今日热瓜 <span className="text-accent-500">必吃</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">全网最火爆料，一条都不能错过</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featuredArticles.map((article, index) => {
            const isHovered = hoveredIndex === index;
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className={`relative group cursor-pointer rounded-xl overflow-hidden transition-all duration-500 ${
                  isHovered ? 'md:col-span-2' : 'md:col-span-1'
                }`}
                style={{ height: '420px' }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10"></div>

                {article.badge && (
                  <span className="absolute top-4 right-4 px-3 py-1 bg-accent-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
                    {article.badge}
                  </span>
                )}

                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-white leading-snug mb-2">
                    {article.title}
                  </h3>
                  <p className="text-white/70 text-sm leading-relaxed transition-all duration-300 opacity-0 max-h-0 md:group-hover:opacity-100 md:group-hover:max-h-20 overflow-hidden">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-4 mt-3 text-white/50 text-xs">
                    <span className="whitespace-nowrap">{article.date}</span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line"></i>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line"></i>
                      {article.comments >= 10000 ? `${(article.comments / 10000).toFixed(1)}万` : article.comments}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}